export default "__VITE_ASSET__CsxERZqm__"